module.exports = __webpack_public_path__ + "img/1.b7e83773.jpg";